export default "__VITE_ASSET__07bac887__"